import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useCookieConsent } from '../../contexts/CookieContext';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();
  const { footerColor } = useTheme();
  const { resetConsent } = useCookieConsent();
  const currentYear = new Date().getFullYear();

  const handleCookieSettings = () => {
    resetConsent();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer
      className="footer"
      style={{
        background: `linear-gradient(135deg, ${footerColor.primary} 0%, ${footerColor.secondary} 100%)`
      }}
    >
      <div className="footer-content">
        <div className="footer-section">
          <h3>Lapponia Silent</h3>
          <p>{t('footer.tagline')}</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <p>
            <a href="mailto:martino@lapponiasilent.com">martino@lapponiasilent.com</a>
          </p>
          <p>
            <a href="tel:+46706749998">070-674 99 98</a>
          </p>
          <p>{t('footer.location')}</p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.quickLinks')}</h4>
          <ul>
            <li><Link to="/" state={{ scrollToContent: true }}>{t('navbar.home')}</Link></li>
            <li><Link to="/hunting" state={{ scrollToContent: true }}>{t('navbar.hunting')}</Link></li>
            <li><Link to="/fishing" state={{ scrollToContent: true }}>{t('navbar.fishing')}</Link></li>
            <li><Link to="/nature" state={{ scrollToContent: true }}>{t('navbar.nature')}</Link></li>
            <li><Link to="/about" state={{ scrollToContent: true }}>{t('navbar.about')}</Link></li>
            <li><Link to="/faq" state={{ scrollToContent: true }}>{t('navbar.faq')}</Link></li>
            <li><Link to="/contact" state={{ scrollToContent: true }}>{t('navbar.contact')}</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.followUs')}</h4>
          <a
            href="https://www.facebook.com/people/Lapponia-Silent/100064481598592/?locale=sv_SE"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link facebook"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Facebook
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; 2007-{currentYear} Lapponia Silent | {t('footer.company')}
        </p>
        <p>
          {t('footer.rights')} | <button onClick={handleCookieSettings} className="cookie-settings-link">{t('footer.cookieSettings')}</button>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
